module.exports = __webpack_public_path__ + "static/media/brian-fox_200x200 copy.4eed6dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/brian-fox_200x200 copy.png
// module id = 199
// module chunks = 0